import type { ReactNode } from "react";

type Props = {
  icon: ReactNode;
  title: ReactNode;
  description: ReactNode;
};

export const Row = (props: Props) => {
  const { title, description, icon } = props;
  return (
    <div className="flex gap-x-4">
      {icon}
      <div className="flex flex-col text-white">
        <div className="flex text-lg leading-5.5 font-medium tracking-tight">
          {title}
        </div>
        <p className="mt-0.5 text-sm leading-4.5 tracking-[0.5px] opacity-50">
          {description}
        </p>
      </div>
    </div>
  );
};
